// src/utils/multiServiceAvailability.js
// Shared rule for whether a staff member can take more than one service in the same time slot.

/**
 * Half-open interval overlap check.
 */
export const rangesOverlap = (startA, endA, startB, endB) => {
  return startA < endB && endA > startB;
};

/**
 * How many concurrent bookings a service's "% of time shared" allows.
 * Locked at 50% in the admin UI today, which yields a capacity of 2.
 */
export const getSlotSharingCapacity = (service) => {
  const percentage = service?.concurrentTimePercentage;
  const pct = (typeof percentage === 'number' && percentage > 0) ? percentage : 50;
  return Math.max(1, Math.floor(100 / pct));
};

/**
 * Can `staff` take one more booking in a slot that already has `overlappingServices`
 * booked into it? Pass `requestedService` when checking a specific candidate booking;
 * omit it for a general "does this staff still have room here" display check.
 */
export const canShareSlot = (staff, overlappingServices, requestedService = null) => {
  if (!staff?.allowMultipleServices) return false;

  const relevantServices = requestedService
    ? [...overlappingServices, requestedService]
    : overlappingServices;

  if (relevantServices.some(s => !s?.allowConcurrentBooking)) return false;

  const capacity = relevantServices.length > 0
    ? Math.min(...relevantServices.map(getSlotSharingCapacity))
    : getSlotSharingCapacity(null);

  return overlappingServices.length < capacity;
};
